<template>
    <div v-if="couponCode !== null">
        <b-modal
            size="lg"
            v-model="modalShow"
            title="クーポンコード編集"
            @hidden="close">
            <form @submit.stop.prevent="editCouponCode">
                <div class="row">
                    <div class="col">
                        <div>{{ couponCode.coupon_name }}</div>
                        <div class="small text-muted mb-4">{{ couponCode.campaign_name }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group m-form__group">
                            <div class="d-flex align-items-start mb-2">
                                <div class="form-check mr-2 formCheckIsEnabled formCheckIsEnabledMarginTop">
                                    <input
                                        v-model="couponCode.is_enabled"
                                        :disabled="couponCode.used_coupon_code_count > 0"
                                        value="1"
                                        type="checkbox"
                                        id="is_enabled"
                                        name="is_enabled"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_enabled">
                                        有効
                                    </label>
                                </div>
                                <div class="mr-2">
                                    <label class="is-required-ja">クーポンコード</label>
                                    <input
                                        v-model="couponCode.code"
                                        :disabled="couponCode.user_coupons_count > 0"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors['code'] }"
                                        style="max-width:256px;"
                                        type="text"
                                        placeholder="例）ABCD1234">
                                    <div
                                        v-if="errors['code']"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors['code'][0] }}
                                    </div>
                                </div>
                                <div class="mr-2">
                                    <label>使用数上限</label>
                                    <input
                                        v-model="couponCode.use_limit"
                                        :disabled="couponCode.used_coupon_code_count > 0"
                                        class="form-control m-input"
                                        :class="{ 'is-invalid' : errors['use_limit'] }"
                                        style="max-width:230px;"
                                        type="text"
                                        placeholder="例）100">
                                    <div
                                        v-if="errors['use_limit']"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors['use_limit'][0] }}
                                    </div>
                                </div>
                                <div>
                                    <label>使用数</label>
                                    <input
                                        :value="couponCode.user_coupons_count"
                                        disabled
                                        class="form-control m-input"
                                        style="max-width:80px;"
                                        type="text">
                                </div>
                            </div>

                            <div class="couponCodeRemarksWrapper">
                                    <textarea
                                        v-model="couponCode.remarks"
                                        rows="1"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors['remarks'] }"
                                        placeholder="備考欄">
                                    </textarea>
                                <div
                                    v-if="errors['remarks']"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors['remarks'][0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div
                slot="modal-footer"
                class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button
                    class="btn btn-yokumiru-orange float-right"
                    style="width:90px;"
                    :disabled="inProgress"
                    @click="handleOk">
                    保存
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                inProgress: false,
                modalShow: false,
                couponCode: null,
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-admin-edit-coupon-code', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-admin-edit-coupon-code')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {object} couponCode
             */
            open: function (couponCode) {
                this.couponCode = { ...couponCode }
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
                this.errors = {}
            },

            handleOk(e) {
                e.preventDefault()
                this.editCouponCode()
            },

            /**
             * クーポンコード編集
             */
            editCouponCode: async function () {
                if (this.inProgress) return
                this.inProgress = true

                await axios.put(`${constants.admin.coupon_codes.endpoint.base}/${this.couponCode.id}`, this.couponCode)
                    .then(() => {
                        bus.$emit('alert-success', 'クーポンコードを更新しました。')
                        bus.$emit('coupon-code-edited')
                        this.errors = {}
                        this.close()
                    })
                    .catch(({response}) => {
                        if (
                            response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')
                        ) {
                            if (response.data.errors.hasOwnProperty('message')) {
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            }
                            else {
                                bus.$emit('alert-danger')
                                this.errors = response.data.errors
                            }
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    });

                this.inProgress = false
            },
        },
    }
</script>

<style lang="scss" scoped>
.couponCodeRemarksWrapper {
    max-width: 520px;
}

.couponButton {
    width: 37px;
    height: 37px;
    margin-left: 10px;
    line-height: 37px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background: #4E7DAB;
    border-radius: 5px;
    cursor: pointer;

    &.couponButtonRemove {
        color: #818181;
        background: #e8e8e8;
    }

    &.couponButtonMarginTop {
        margin-top: 31px;
    }
}

.formCheckIsEnabled {
    margin-top: 7px;

    &.formCheckIsEnabledMarginTop {
        margin-top: 38px;
    }

    input, label {
        cursor: pointer;
    }
}
</style>
